import React, { FC } from 'react';
import classes from './CustomIconButton.module.css';

type CustomIconButtonProps = {
  title: string;
  icon?: React.ReactNode;
  clickHandler?: () => any;
  className?: string;
  spanClassName?: string;
  type?: 'default' | 'primary';
};

const CustomIconButton: FC<CustomIconButtonProps> = ({
  title,
  icon,
  clickHandler,
  className,
  spanClassName,
  type,
}) => {
  return (
    <button
      className={[
        classes.IconButton,
        type === 'primary' ? classes.IconButtonPrimary : '',
        className,
      ].join(' ')}
      onClick={clickHandler}
    >
      {icon && type !== 'primary' && <div className="me-1">{icon}</div>}

      <span style={{ paddingLeft: 10 }}>{title}</span>
      {icon && type === 'primary' && <div className="me-1">{icon}</div>}
    </button>
  );
};

export default CustomIconButton;
